<script lang="ts" setup>
import { onMounted, ref } from "vue";
import SidebarMenu from "@/components/SidebarMenu.vue";
import AbsolutePageHeader from "@/components/headers/AbsolutePageHeader.vue";
import TagSidebarItems from "@/components/sidebar/TagSidebarItems.vue";
import BlogSearch from "@/views/Blogs/components/BlogSearch.vue";
import BlogGrid from "@/views/Blogs/components/BlogGrid.vue";
import { blogPage } from "@/constants/breadcrumbs";
import { useBlogsStore } from "@/stores/blogsStore";
import ShowMoreButton from "@/views/Blogs/components/ShowMoreButton.vue";
import { useBlogTagsStore } from "@/stores/blogTagsStore";
import PageFooter from "@/components/PageFooter.vue";

const blogsCardsStore = useBlogsStore();
const tagsStore = useBlogTagsStore();

const isMenuOpen = ref(false);

onMounted(() => {
  if (blogsCardsStore.blogList.length === 0) {
    blogsCardsStore.fetchBlogsCards();
  }
});

function loadMoreBlogs() {
  if (!blogsCardsStore.hasNextPage) {
    return;
  }
  blogsCardsStore.loadNextPage();
}

function searchBlog(search: string) {
  if (!search) {
    blogsCardsStore.fetchBlogsCards();
  } else {
    blogsCardsStore.searchBlogs(search);
  }
  tagsStore.resetSelectedTag();
}
</script>

<template>
  <div
    class="flex xl:flex-row flex-col xl:h-screen bg-secondary overflow-y-visible no-scrollbar"
  >
    <SidebarMenu
      :show-blog-btn="false"
      :is-menu-open="isMenuOpen"
      @toggle-menu="isMenuOpen = !isMenuOpen"
      class="sticky top-0"
    >
      <TagSidebarItems @close-menu="isMenuOpen = false" />
    </SidebarMenu>

    <main class="relative flex-1 flex flex-col">
      <AbsolutePageHeader :show-blog-btn="false" :breadcrumbs="blogPage" />

      <div class="flex-1 xl:overflow-y-auto no-scrollbar mb-16 xl:mb-0">
        <BlogSearch @search="searchBlog" />
        <BlogGrid :blog-list="blogsCardsStore.blogList" />
        <ShowMoreButton
          v-if="blogsCardsStore.hasNextPage"
          @load-more-blogs="loadMoreBlogs"
          :is-api-loading="blogsCardsStore.isListLoading"
        />
      </div>
      <div class="fixed bottom-0 left-0 w-full">
        <PageFooter />
      </div>
    </main>
  </div>
</template>
